import Icon from '@mdi/react'
import theme from 'theme_'
import styled from 'styled-components'

export const NameIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  position: absolute;
  top: -5px;
  left: 0;
  color: ${theme.colors.dolphinGrey};
`

export const NameCellWrapper = styled.div`
  padding-left: 40px;
  position: relative;
  color: ${theme.colors.otterWarmBlack};
  font-weight: 900;
`
